import { composeWithDevTools } from '@redux-devtools/extension';
import { throttle } from 'lodash-es';
import { compose as composeOriginal } from 'redux';
import { isNodeEvnProduction } from './env';
export function batchActionPayload(dispatch, actionType, delay = 1000) {
    const payloads = [];
    const throttleDispatch = throttle(() => {
        dispatch({
            type: actionType,
            payload: [...payloads]
        });
        payloads.length = 0;
    }, delay);
    const batchFunc = (payload) => {
        payloads.push(payload);
        throttleDispatch();
    };
    batchFunc.flush = throttleDispatch.flush;
    return batchFunc;
}
export function compose(name, ...enhancers) {
    if (isNodeEvnProduction()) {
        return composeOriginal(...enhancers);
    }
    return composeWithDevTools({
        shouldHotReload: true,
        name
    })(...enhancers);
}
